import React, { Component } from "react";
import classnames from "classnames";
import styles from "./Components.local.scss";
import ComponentActions from "./ComponentActions";

class GeneratedRemarkComponent extends Component {
  render() {
    const { component } = this.props;

    const {
      data: {
        data: { remark, status }
      }
    } = component;

    return (
      <div>
        <div
          className={classnames(
            styles.remark,
            styles.flex_container,
            styles.align_container,
            status === "positive"
              ? styles.positive_status_border
              : styles.negative_status_border
          )}
        >
          <div
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
          >
            {!this.props.inSlideView &&
              !this.props.isEmbedded && (
                <ComponentActions
                  removeComponent={this.props.handleRemoveComponent}
                  updateComponent={this.props.handleUpdateComponent}
                  componentCase={this.props.ComponentCase}
                  sideBar={"ComponentConfig"}
                  component={"GeneratedRemarkComponent.png"}
                />
              )}
            <span
              dangerouslySetInnerHTML={{
                __html: remark
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default GeneratedRemarkComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/GeneratedRemarkComponent.js